/** Default line works cross-section template, in metric display units. */
export const defaultLineWorksCrossSection = () => ({
	leftWidth: 20,
	rightWidth: 20,
	interpolationPitch: 20,
	samplingSize: 0.5,
});

const FEET_DISPLAY_DEFAULTS = {
	leftWidth: 60,
	rightWidth: 60,
	interpolationPitch: 60,
	samplingSize: 0.5,
};

/** Display defaults by distance unit (FEET and US_SURVEY_FEET share the same values) */
const DISPLAY_DEFAULTS_BY_DISTANCE_UNIT = {
	METERS: {
		leftWidth: 20,
		rightWidth: 20,
		interpolationPitch: 20,
		samplingSize: 0.5,
	},
	FEET: FEET_DISPLAY_DEFAULTS,
	US_SURVEY_FEET: FEET_DISPLAY_DEFAULTS,
};

export const defaultLineWorksCrossSectionByDistanceUnit = (
	distanceUnit,
	fromDisplayToMeters,
) => {
	const displayDefaults =
		DISPLAY_DEFAULTS_BY_DISTANCE_UNIT[distanceUnit] ??
		DISPLAY_DEFAULTS_BY_DISTANCE_UNIT.METERS;
	const toInternal =
		typeof fromDisplayToMeters === "function"
			? fromDisplayToMeters
			: (value) => value;

	return {
		leftWidth: toInternal(displayDefaults.leftWidth),
		rightWidth: toInternal(displayDefaults.rightWidth),
		interpolationPitch: toInternal(displayDefaults.interpolationPitch),
		samplingSize: displayDefaults.samplingSize,
	};
};
